import React from 'react'
import {
  historyAndPhysicalNotesColumns,
} from '../../constants/ProfillingConstants'
import CustomTable from '../../shared/CustomTable'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

function HistoryPhysicalNotes () {
  const { t } = useTranslation()
  const { isLoading, patientDoctorNotes } = useSelector(
    state => state?.notes
  )

  return (
    <div className=''>
      <CustomTable
        isLoading={isLoading}
        columns={historyAndPhysicalNotesColumns(t)}
        data={
          patientDoctorNotes?.data?.history_notes?.map(data => ({
            ...data,
            createdAt: data?.created_at,
            updatedAt:data?.updated_at
          })) || []
        }
      />
    </div>
  )
}

export default HistoryPhysicalNotes
